/**
 * Calendar Vuex Store Module
 * 
 * Manages calendar user preferences with local storage persistence.
 */

export const state = () => ({
    // User preferences for calendar view
    currentView: 'month',
    currentFocus: '',
    selectedAgentId: null,
    expandedWeekIndex: null,
})

export const mutations = {
    /**
     * Set current calendar view type
     */
    SET_VIEW(state, viewType) {
        state.currentView = viewType
    },
    
    /**
     * Set current focus date
     */
    SET_FOCUS(state, focusDate) {
        state.currentFocus = focusDate
    },
    
    /**
     * Set selected agent ID
     */
    SET_SELECTED_AGENT(state, agentId) {
        state.selectedAgentId = agentId
    },

    /**
     * Set expanded week index in month grid
     */
    SET_EXPANDED_WEEK(state, weekIndex) {
        state.expandedWeekIndex = weekIndex
    },
}

export const actions = {
    /**
     * Change calendar view type
     */
    changeView({ commit }, viewType) {
        commit('SET_VIEW', viewType)
    },
    
    /**
     * Change focus date
     */
    changeFocus({ commit }, focusDate) {
        commit('SET_FOCUS', focusDate)
    },
    
    /**
     * Change selected agent
     */
    changeSelectedAgent({ commit }, agentId) {
        commit('SET_SELECTED_AGENT', agentId)
    },

    /**
     * Set expanded week index
     */
    expandWeek({ commit }, weekIndex) {
        commit('SET_EXPANDED_WEEK', weekIndex)
    },
}


